import React, {useState} from 'react';
import IconTextView, {INPUT_TYPE} from "../../../components/input/IconTextView";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import CustomCheckBox from "components/checkBox/CustomCheckBox";
import {useHistory} from "react-router-dom";
import {getButtonHeight, getTextViewHeight, IsF, IsM, IsSM, IsT} from "my-styles/media/media";
import {authenticationViewModel} from "../../../viewModels/Authentication.viewModel";
import messages from "res/messages/farsi";

import ICArrowBackIosIcon from "res/images/left_arrow.png";
import ICInvite from "res/images/title.png";
import ICPhone from "res/images/phone.png";
import ICFantasticBg1 from "res/images/fantastic_bg_1.png";
import ICFantasticBg2 from "res/images/fantastic_bg_2.png";
import ICLoginPhone from "res/images/login_phone.png";

export default function Login(props) {

    const history = useHistory()

    const [agreementCheckedStatus, setAgreementCheckedStatus] = useState(true)
    const [telephone, setTelephone] = useState("")
    const [invitedCode, setInvitedCode] = useState("")

    function checkLogin() {
        if (agreementCheckedStatus) {
            requestLogin()
        } else {
            props.onAlert(messages.pleaseCheckAggrement)
        }
    }

    function requestLogin() {
        if (telephone) {
            authenticationViewModel.login(telephone,
                () => {
                    props.onNavigate(history, "/verify",
                        {invitedCode: invitedCode, telephone: telephone})
                },
                (data) => {
                    let message = messages.sendVerifyCodeError
                    if (data !== undefined && data.description !== undefined) {
                        if (data.description === 103) {
                            message = messages.wrongPhoneNumber
                        }
                        if (data.description === 104) {
                            message = messages.timeVerifyCodeError
                        }
                    }
                    props.onAlert(message)
                }, () => {
                    props.onLoading(true)
                }, () => {
                    props.onLoading(false)
                }
            )
        } else {
            props.onAlert(messages.enterTelephone)
        }
    }

    return (IsSM() || IsM() ?
        <div className="marginSmall" style={{
            backgroundImage: 'url(' + ICFantasticBg2 + ')',
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        }}>
            <table className="fullWidth center" style={{height: "35em"}}>
                <tbody>
                <tr>
                    <td>
                        <center>
                            <div style={{width: "60%"}}>
                                <IconTextView
                                    type={INPUT_TYPE.PHONE_NUMBER}
                                    height={getTextViewHeight()}
                                    placeholder={messages.telephone}
                                    maxlength="11"
                                    icon={<img alt={"صرفه مارکت"} src={ICPhone} className="marginSmall xSmallIcon"/>}
                                    onChange={(e) => {
                                        setTelephone(e.target.value)
                                    }}
                                    onEnterClick={() => {
                                        checkLogin()
                                    }}/>
                            </div>
                            <div style={{width: "60%"}}>
                                <IconTextView
                                    type={INPUT_TYPE.NUMBER}
                                    height={getTextViewHeight()}
                                    placeholder={messages.inviteCode}
                                    icon={<img alt={"صرفه مارکت"} src={ICInvite} className="marginSmall xSmallIcon"/>}
                                    onChange={(e) => {
                                        setInvitedCode(e.target.value)
                                    }}
                                    onEnterClick={() => {
                                        checkLogin()
                                    }}/>
                            </div>
                            <div style={{width: "80%"}} className="mediumTextBold">
                                <CustomCheckBox
                                    checked={agreementCheckedStatus}
                                    onClick={() => {
                                        setAgreementCheckedStatus(!agreementCheckedStatus)
                                    }}/>
                                <label className="clickable" style={{color: "var(--blue_3)"}}
                                       onClick={() => {
                                           props.onNavigate(history, '/aggrement')
                                       }}>
                                    {messages.roleAndCondition}
                                </label>
                                <label>
                                    {messages.readAndAccept}
                                </label>
                            </div>
                            <div style={{marginTop: "3em", width: "60%"}}>
                                <IconTitleButtonRound
                                    height={getButtonHeight()}
                                    fontSize="mediumTextBold"
                                    onClick={() => {
                                        if (agreementCheckedStatus) {
                                            requestLogin()
                                        } else {
                                            props.onAlert(messages.pleaseCheckAggrement)
                                        }
                                    }}
                                    icon={<img alt={"صرفه مارکت"} src={ICArrowBackIosIcon} className="marginSmall xSmallIcon"/>}
                                    title={messages.enter}/>
                            </div>
                        </center>
                    </td>
                </tr>
                </tbody>
            </table>
        </div> :
        IsF() ?
            <div className="marginSmall" style={{
                backgroundImage: 'url(' + ICFantasticBg2 + ')',
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }}>
                <table className="fullWidth center" style={{height: "35em"}}>
                    <tbody>
                    <tr>
                        <td>
                            <center>
                                <div style={{width: "55%"}}>
                                    <IconTextView
                                        type={INPUT_TYPE.PHONE_NUMBER}
                                        height={getTextViewHeight()}
                                        placeholder={messages.telephone}
                                        maxlength="11"
                                        icon={<img alt={"صرفه مارکت"} src={ICPhone} className="marginSmall xSmallIcon"/>}
                                        onChange={(e) => {
                                            setTelephone(e.target.value)
                                        }}
                                        onEnterClick={() => {
                                            checkLogin()
                                        }}/>
                                </div>
                                <div style={{width: "55%"}}>
                                    <IconTextView
                                        type={INPUT_TYPE.NUMBER}
                                        height={getTextViewHeight()}
                                        placeholder={messages.inviteCode}
                                        icon={<img alt={"صرفه مارکت"} src={ICInvite} className="marginSmall xSmallIcon"/>}
                                        onChange={(e) => {
                                            setInvitedCode(e.target.value)
                                        }}
                                        onEnterClick={() => {
                                            checkLogin()
                                        }}/>
                                </div>
                                <div style={{width: "55%"}} className="mediumTextBold">
                                    <CustomCheckBox
                                        checked={agreementCheckedStatus}
                                        onClick={() => {
                                            setAgreementCheckedStatus(!agreementCheckedStatus)
                                        }}/>
                                    <label className="clickable" style={{color: "var(--blue_3)"}}
                                           onClick={() => {
                                               props.onNavigate(history, '/aggrement')
                                           }}>
                                        {messages.roleAndCondition}
                                    </label>
                                    <label>
                                        {messages.readAndAccept}
                                    </label>
                                </div>
                                <div style={{marginTop: "3em", width: "55%"}}>
                                    <IconTitleButtonRound
                                        height={getButtonHeight()}
                                        fontSize="mediumTextBold"
                                        onClick={() => {
                                            if (agreementCheckedStatus) {
                                                requestLogin()
                                            } else {
                                                props.onAlert(messages.pleaseCheckAggrement)
                                            }
                                        }}
                                        icon={<img alt={"صرفه مارکت"} src={ICArrowBackIosIcon}
                                                   className="marginSmall xSmallIcon"/>}
                                        title={messages.enter}/>
                                </div>
                            </center>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div> :
            IsT() ?
                <div className="marginSmall" style={{
                    backgroundImage: 'url(' + ICFantasticBg2 + ')',
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }}>
                    <tbody>
                    <table className="fullWidth center" style={{height: "35em"}}>
                        <tbody>
                        <tr>
                            <td>
                                <center>
                                    <div style={{width: "40%"}}>
                                        <IconTextView
                                            type={INPUT_TYPE.PHONE_NUMBER}
                                            height={getTextViewHeight()}
                                            placeholder={messages.telephone}
                                            maxlength="11"
                                            icon={<img alt={"صرفه مارکت"} src={ICPhone} className="marginSmall xSmallIcon"/>}
                                            onChange={(e) => {
                                                setTelephone(e.target.value)
                                            }}
                                            onEnterClick={() => {
                                                checkLogin()
                                            }}/>
                                    </div>
                                    <div style={{width: "40%"}}>
                                        <IconTextView
                                            type={INPUT_TYPE.NUMBER}
                                            height={getTextViewHeight()}
                                            placeholder={messages.inviteCode}
                                            icon={<img alt={"صرفه مارکت"} src={ICInvite} className="marginSmall xSmallIcon"/>}
                                            onChange={(e) => {
                                                setInvitedCode(e.target.value)
                                            }}
                                            onEnterClick={() => {
                                                checkLogin()
                                            }}/>
                                    </div>
                                    <div style={{width: "40%"}} className="mediumTextBold">
                                        <CustomCheckBox
                                            checked={agreementCheckedStatus}
                                            onClick={() => {
                                                setAgreementCheckedStatus(!agreementCheckedStatus)
                                            }}/>
                                        <label className="clickable" style={{color: "var(--blue_3)"}}
                                               onClick={() => {
                                                   props.onNavigate(history, '/aggrement')
                                               }}>
                                            {messages.roleAndCondition}
                                        </label>
                                        <label>
                                            {messages.readAndAccept}
                                        </label>
                                    </div>
                                    <div style={{marginTop: "3em", width: "40%"}}>
                                        <IconTitleButtonRound
                                            height={getButtonHeight()}
                                            fontSize="mediumTextBold"
                                            onClick={() => {
                                                if (agreementCheckedStatus) {
                                                    requestLogin()
                                                } else {
                                                    props.onAlert(messages.pleaseCheckAggrement)
                                                }
                                            }}
                                            icon={<img alt={"صرفه مارکت"} src={ICArrowBackIosIcon}
                                                       className="marginSmall xSmallIcon"/>}
                                            title={messages.enter}/>
                                    </div>
                                </center>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </tbody>
                </div> :
                <div className="horizontalFullScreen">
                    <div className="formContainer">
                        <table className="background full" style={{backgroundImage: 'url(' + ICFantasticBg2 + ')'}}>
                            <tbody>
                            <tr>
                                <td>
                                    <center>
                                        <div className="halfWidth">
                                            <IconTextView
                                                type={INPUT_TYPE.PHONE_NUMBER}
                                                height={getTextViewHeight()}
                                                placeholder={messages.telephone}
                                                maxlength="11"
                                                icon={<img alt={"صرفه مارکت"} src={ICPhone} className="marginSmall xSmallIcon"/>}
                                                onChange={(e) => {
                                                    setTelephone(e.target.value)
                                                }}
                                                onEnterClick={() => {
                                                    checkLogin()
                                                }}/>
                                        </div>
                                        <div className="halfWidth">
                                            <IconTextView
                                                type={INPUT_TYPE.NUMBER}
                                                height={getTextViewHeight()}
                                                placeholder={messages.inviteCode}
                                                icon={<img alt={"صرفه مارکت"} src={ICInvite} className="marginSmall xSmallIcon"/>}
                                                onChange={(e) => {
                                                    setInvitedCode(e.target.value)
                                                }}
                                                onEnterClick={() => {
                                                    checkLogin()
                                                }}/>
                                        </div>
                                        <div className="twoFromThree mediumTextBold">
                                            <CustomCheckBox
                                                checked={agreementCheckedStatus}
                                                onClick={() => {
                                                    setAgreementCheckedStatus(!agreementCheckedStatus)
                                                }}/>
                                            <label className="clickable" style={{color: "var(--blue_3)"}}
                                                   onClick={() => {
                                                       props.onNavigate(history, '/aggrement')
                                                   }}>
                                                {messages.roleAndCondition}
                                            </label>
                                            <label>
                                                {messages.readAndAccept}
                                            </label>
                                        </div>
                                        <div className="halfWidth" style={{marginTop: "3em"}}>
                                            <IconTitleButtonRound
                                                height={getButtonHeight()}
                                                fontSize="mediumTextBold"
                                                onClick={() => {
                                                    checkLogin()
                                                }}
                                                icon={<img alt={"صرفه مارکت"} src={ICArrowBackIosIcon}
                                                           className="marginSmall xSmallIcon"/>}
                                                title={messages.enter}/>
                                        </div>
                                    </center>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="imageContainer">
                        <img className="leftSideBg" src={ICFantasticBg1} alt={"صرفه مارکت"}/>
                        <img className="leftSideIcon" src={ICLoginPhone} alt={"صرفه مارکت"} />
                    </div>
                </div>)

}